import React, { useEffect } from "react";

const faqs = [
  {
    question: "Are your cleaning agents safe for home use?",
    answer:
      "Yes, our cleaning products are formulated with user safety in mind. We offer both industrial and home-grade solutions—always check the label for dilution and handling instructions.",
  },
  {
    question: "Do your pesticides harm beneficial insects like bees?",
    answer:
      "We provide both broad-spectrum and eco-friendly targeted pesticides. If protecting pollinators is a priority, ask for our bee-safe or organic-certified options.",
  },
  {
    question: "Can I mix different cleaning chemicals together for stronger results?",
    answer:
      "No, never mix cleaning agents unless explicitly mentioned. Combining certain chemicals (like bleach and ammonia) can release toxic gases and pose health risks.",
  },
  {
    question: "Are your products compliant with environmental regulations?",
    answer:
      "Absolutely. Our formulations meet national and international standards, including ISO and REACH compliance for safety and environmental sustainability.",
  },
  {
    question: "How should I store pesticides and cleaning chemicals?",
    answer:
      "Store in a cool, dry, well-ventilated place away from direct sunlight and food. Always keep containers tightly sealed and out of children's reach.",
  },
];

const FAQ = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-gray-50">
      {/* Header Section */}
      <div className="flex justify-center py-10 lg:py-20 bg-gradient-to-r from-green-200 via-indigo-100 to-green-100 w-full bg-cover bg-no-repeat bg-bottom">
        <div className="flex mx-auto w-full max-w-screen-2xl px-3 sm:px-10">
          <div className="w-full flex justify-center flex-col relative">
            <h2 className="text-2xl md:text-4xl lg:text-5xl font-extrabold text-center text-gray-800 tracking-tight drop-shadow-md">
              FAQ
            </h2>
          </div>
        </div>
      </div>

      {/* FAQ Section */}
      <div className="bg-white">
        <div className="max-w-screen-2xl mx-auto lg:py-20 py-10 px-4 sm:px-10">
          <div className="grid grid-flow-row gap-6">
            {faqs.map((faq, idx) => (
              <div
                key={idx}
                className="border rounded-2xl shadow-sm p-6 hover:shadow-md transition"
              >
                <h3 className="font-semibold text-lg text-gray-900">
                  {faq.question}
                </h3>
                <p className="mt-2 text-gray-700">{faq.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQ;